import CarouselItem from "MiniSiteComponents/Carousel/Carousel.interface";
import ComponentImage from "GeneralComponents/ComponentImage";
import LimitedContent from "GeneralComponents/LimitedContent";

type Props = { tabitemcontent: CarouselItem; isTablet: boolean; };

const TabContentTextBox: React.FC<Props> = ({ tabitemcontent, isTablet }) => {

    if (!isTablet) {
        return <>
            <div dangerouslySetInnerHTML={{ __html: tabitemcontent.richDescription }}></div>
            <div dangerouslySetInnerHTML={{ __html: tabitemcontent.content }}></div>
        </>
    }

    return ((tabitemcontent.image?.url || tabitemcontent.mobileImage?.url) ?
        <div className="mst-tab-content-img-box">
            <ComponentImage
                image={tabitemcontent.image}
                imageClass=""
                mobileImage={tabitemcontent.mobileImage}
                mobileImageClass=""
                wrapperDivClass="" />

            <LimitedContent htmlContent={tabitemcontent.richDescription} classNames="mst-tab-content-limited"></LimitedContent>
            <div dangerouslySetInnerHTML={{ __html: tabitemcontent.richDescription }} className="mst-tab-content-unlimited" />
            <LimitedContent htmlContent={tabitemcontent.content} classNames="mst-tab-content-limited"></LimitedContent>
            <div dangerouslySetInnerHTML={{ __html: tabitemcontent.content }} className="mst-tab-content-unlimited" />

        </div>
        :
        <>
            <div dangerouslySetInnerHTML={{ __html: tabitemcontent.richDescription }} className="mst-tab-content-unlimited" />
            <LimitedContent htmlContent={tabitemcontent.richDescription} classNames="mst-tab-content-limited"></LimitedContent>
            <div className="d-block">
                <LimitedContent htmlContent={tabitemcontent.content} classNames="mst-tab-content-limited"></LimitedContent>
                <div dangerouslySetInnerHTML={{ __html: tabitemcontent.content }} className="mst-tab-content-unlimited" />
            </div>
        </>
    )
}

export default TabContentTextBox;